import "./Header.css";
import img1 from "../../assets/2.jpg";
import planMe from "../../assets/3.jpg";
import findVendors from "../../assets/1.jpg";
import img4 from "../../assets/Rectangle 28.png";

import { Link } from "react-router-dom";
import Card from "./Card";

const cardContents = [
  {
    img: findVendors,
    title: "Get Vendors",
    desc: "Share your vision once — and let verified professionals compete to deliver excellence.",
    buttonText: "Find vendors",
    btnLink: "/get-vendors"
},
  {
    img: img1,
    title: "Find a Venue",
    desc: "Enjoy access to verified venues, thoughtfully curated to meet the standards of your event and budget.",
    buttonText: "Find venues",
    btnLink: "/get-venue"
},
  {
    img: planMe,
    title: "Plan for me",
    desc: "Share your vision, and we’ll connect you with verified planners and stay in touch to ensure everything comes together perfectly.",
    buttonText: "Start planning",
    btnLink: "/plan-for-me"
},
]

export default function Header() {
  return (
    <div className="header justify-content-evenly gap-5">
      <div className="form-wrapper">
        <h1>
          Plan Events Effortlessly.
        </h1>
        <p className="quickp-desc">
          
          Choose how you want it done — DIY, assisted or fully handled.
        </p>
        
        <div className="button-group">
          {/* <Link to='/event-details' className="get-started-btn">Connect with vendors</Link> */}
          <div className="download-buttons">
            <a href="#" target="_blank" rel="noreferrer">
              <img
                src="/app-store.svg"
                alt="Download on the App Store"
                className="app-store-badge"
              />
            </a>
            <a href="#" target="_blank" rel="noreferrer">
              <img
                src="/google-play.svg"
                alt="Get it on Google Play"
                className="google-play-badge"
              />
            </a>
          </div>
        </div>
      </div>

      <div className="hero d-flex justify-content-evenly mt-5 gap-4">
        {/* <div className="hero-circle"></div>
        <div className="hero-wrapper">
          <img src={img1} alt="Event planning" className="first-img" />
          <img src={img2} alt="Event planning" />

          <div className="small-img one">
            <img src={img3} alt="Event planning" />
          </div>
          <div className="small-img two">
            <img src={img4} alt="Event planning" />
          </div>
        </div> */}
       {cardContents.map(items => <Card key={items.title} img={items.img} title={items.title} desc={items.desc} buttonText={items.buttonText} btnLink={items.btnLink} />)}
      </div>
    </div>
  );
}
